var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-section" },
    [
      _vm.selectedPaymentMethod.includes("boleto")
        ? _c("payment-boleto")
        : _vm._e(),
      _vm.selectedPaymentMethod.includes("credit_card")
        ? _c("payment-credit-card")
        : _vm._e(),
      _vm.selectedPaymentMethod.includes("checkout")
        ? _c("payment-link")
        : _vm._e(),
      _c("payment-pix", {
        attrs: { selectedPaymentMethod: _vm.selectedPaymentMethod },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }